import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import ButtonForm from 'components/buttons/button-form';
import { useStep3 } from './useStep3';

const Step3: React.FC = () => {
  const {
    formulario,
    validarCamposObrigatorios,
    checkRadio,
    handleNomeServidorChange,
    removerCampoServidor,
    adicionarCampoServidor,
    handleAvancar,
    handleVoltar,
    setPartialForm,
    formularioInativo,
    stepAtual,
    totalSteps,
  } = useStep3();

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mt: 4,
          mb: 4,
          fontSize: '24px',
          fontWeight: 400,
          textAlign: 'center'
        }}
      >
        Informações sobre Órgãos Estaduais
      </Typography>
      <ContainerFormFormik title='Escritórios de Órgãos Estaduais'>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >
          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              O município possui escritório da Empaer?
            </FormLabel>

            <RadioGroup
              aria-labelledby='foreigner-label'
              defaultValue={formulario?.possui_escritorio_empaer}
              name='radio-buttons-group'
              value={formulario?.possui_escritorio_empaer}
              onChange={(e) => checkRadio(e, 'possui_escritorio_empaer')}
            >
              <FormControlLabel value={true} control={<Radio />} label='Sim' />
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl component='fieldset'>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', color: '#333' }}>
              O município possui Termo de Cooperação com a Empaer?
            </FormLabel>
            <RadioGroup
              aria-label='empresa-parceria'
              name='empresa-parceria-radio-buttons-group'
              value={formulario?.desenvolve_projetos_empaer}
              onChange={(e) => checkRadio(e, 'desenvolve_projetos_empaer')}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'wrap',
                }}
              >
                {' '}
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label='Sim'
                  sx={{
                    mr: formulario?.desenvolve_projetos_empaer === true ? 1 : 0,
                  }}
                />
                {formulario?.desenvolve_projetos_empaer === true && (
                  <TextField
                    id='project-name'
                    // label="Nome do projeto" // Pode ser redundante se o placeholder for claro
                    placeholder='Escreva o nome do projeto executado em parceria com a EMPAER'
                    variant='outlined'
                    value={formulario?.projeto_empaer_nome ?? ''}
                    onChange={(e) =>
                      setPartialForm('projeto_empaer_nome', e.target.value.toLocaleUpperCase())
                    }
                    size='small' // Para melhor alinhamento vertical com o radio
                    sx={{ flexGrow: 1, minWidth: '250px' }} // Permite que o TextField cresça
                  />
                )}
              </Box>
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl component='fieldset' fullWidth margin='normal' required>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
              <Box component='span' sx={{ color: 'red', mr: 0.5 }}>
                *
              </Box>
              Há algum servidor do município cedido para Empaer?
            </FormLabel>
            <RadioGroup
              aria-label='servidores-cedidos-empaer'
              name='servidoresCedidosEmpaer'
              value={formulario?.servidores_cedidos_empaer}
              onChange={(e) => checkRadio(e, 'servidores_cedidos_empaer')}
            >
              <FormControlLabel
                value={true}
                control={<Radio required />}
                label='Sim'
              />
              <FormControlLabel
                value={false}
                control={<Radio required />}
                label='Não'
              />
            </RadioGroup>

            {formulario?.servidores_cedidos_empaer === true && (
              <Box sx={{ mt: 2, pl: 2, borderLeft: '2px solid #eee' }}>
                <Typography variant='body2' sx={{ mb: 3 }}>
                  Quais? (Preencha o nome completo dos servidores cedidos)
                </Typography>
                {(formulario?.nome_servidores_cedidos_empaer || []).map(
                  (nome, index) => (
                    <Box
                      key={index}
                      sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                    >
                      <TextField
                        label={`Servidor ${index + 1}`}
                        variant='outlined'
                        value={nome}
                        onChange={(e) => handleNomeServidorChange(index, e.target.value.toUpperCase())}
                        fullWidth
                        size='small'
                        required
                        placeholder='Nome completo do servidor'
                      />

                      <IconButton
                        onClick={() => removerCampoServidor(index)}
                        aria-label='Remover servidor'
                        disabled={
                          (formulario?.nome_servidores_cedidos_empaer || [])
                            .length === 1
                        } // Não permite remover se for o último campo
                        color='error'
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Box>
                  ),
                )}
                <Button
                  variant='outlined'
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={adicionarCampoServidor}
                  size='small'
                >
                  Adicionar Servidor
                </Button>
              </Box>
            )}

            {/* Botão de submit de exemplo */}
            {/* <Button onClick={handleSubmit} variant="contained" sx={{ mt: 3 }}>
        Salvar Resposta
      </Button> */}
          </FormControl>

          {/* <FormControl component='fieldset'>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', color: '#333' }}>
              Há algum servidor da Empaer cedido para o município?
            </FormLabel>
            <RadioGroup
              aria-label='empresa-parceria'
              name='empresa-parceria-radio-buttons-group'
              value={formulario?.servidor_empaer_cedido_municipio}
              onChange={(e) =>
                checkRadio(e, 'servidor_empaer_cedido_municipio')
              }
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'wrap',
                }}
              >
                {' '}
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label='Sim'
                  sx={{
                    mr:
                      formulario?.servidor_empaer_cedido_municipio === true
                        ? 1
                        : 0,
                  }}
                />
                {formulario?.servidor_empaer_cedido_municipio === true && (
                  <TextField
                    id='project-name'
                    // label="Nome do projeto" // Pode ser redundante se o placeholder for claro
                    placeholder='Quais?'
                    variant='outlined'
                    value={
                      formulario?.nome_servidor_empaer_cedido_municipio || ''
                    }
                    onChange={(e) =>
                      setPartialForm(
                        'nome_servidor_empaer_cedido_municipio',
                        e.target.value,
                      )
                    }
                    size='small' // Para melhor alinhamento vertical com o radio
                    sx={{ flexGrow: 1, minWidth: '250px' }} // Permite que o TextField cresça
                  />
                )}
              </Box>
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl> */}

          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              O município possui escritórios do Indea?
            </FormLabel>

            <RadioGroup
              aria-labelledby='foreigner-label'
              defaultValue={formulario?.possui_escritorio_indea}
              name='radio-buttons-group'
              value={formulario?.possui_escritorio_indea}
              onChange={(e) => checkRadio(e, 'possui_escritorio_indea')}
            >
              <FormControlLabel value={true} control={<Radio />} label='Sim' />
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              O município possui descentralização ambiental?
            </FormLabel>

            <RadioGroup
              aria-labelledby='foreigner-label'
              defaultValue={formulario?.possui_unidade_sema}
              name='radio-buttons-group'
              value={formulario?.possui_unidade_sema}
              onChange={(e) => checkRadio(e, 'possui_unidade_sema')}
            >
              <FormControlLabel value={true} control={<Radio />} label='Sim' />
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl component='fieldset' fullWidth margin='normal' required>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
              <Box component='span' sx={{ color: 'red', mr: 0.5 }}>
                *
              </Box>
              O município é emissor de Cadastro Nacional da Agricultura Familiar (CAF)?
            </FormLabel>
            <RadioGroup
              aria-label='emissor-caf'
              name='emissor-caf-radio-buttons-group'
              value={formulario?.emissor_caf}
              onChange={(e) => checkRadio(e, 'emissor_caf')}
            >
              <FormControlLabel value={true} control={<Radio required />} label='Sim' />
              <FormControlLabel value={false} control={<Radio required />} label='Não' />
            </RadioGroup>
          </FormControl>
        </Box>
      </ContainerFormFormik>
      <ButtonForm
        disabled={formularioInativo || !validarCamposObrigatorios()}
        onBack={handleVoltar}
        onAdvanced={handleAvancar}
        onSendApproved={handleAvancar}
        stepAtual={stepAtual}
        totalSteps={totalSteps}
      />
    </>
  );
};

export default Step3;
